import * as React from 'react';
import { useHits } from 'react-instantsearch';
import { AlgoliaAnalyticsHelpers, AlgoliaAnalyticsTypes } from '@grandvisionhq/analytics';
import { Text, Chip } from '@grandvisionhq/elements';

function ConnectedHits({ title , indexName  }) {
    const { items  } = useHits();
    const handleClickAnalytics = React.useCallback((hit, index)=>{
        if (hit.__queryID) {
            AlgoliaAnalyticsHelpers.clickedObjectIdsAfterSearch({
                eventName: AlgoliaAnalyticsTypes.AlgoliaAnalyticsEvents.SearchSuggestionClicked,
                objectIds: hit.objectID,
                positions: index + 1,
                queryId: hit.__queryID,
                searchIndex: indexName
            });
        }
    }, [
        indexName
    ]);
    if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        className: "suggestions-hits__title",
        component: "div",
        variant: "body-head"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "suggestions-hits__list"
    }, items.map((hit, index)=>/*#__PURE__*/ React.createElement(Chip, {
            key: hit.objectID,
            href: `?q=${hit.query}`,
            onClick: ()=>handleClickAnalytics(hit, index)
        }, hit.query)
    )));
}

export { ConnectedHits };
//# sourceMappingURL=ConnectedHits.js.map
